export default function StatementTypeLabel ({ children, className }) {
  return (
    <span
      className={`text-cp-grey-600 inline-flex items-center text-left font-normal before:mr-2 before:block xl:before:w-5 xl:before:h-5 lg:before:w-4 lg:before:h-4 before:rounded-md before:border-[3px] ${className}`}
    >
      {children}
    </span>
  );
}